import { render, staticRenderFns } from "./RevenueTable.vue?vue&type=template&id=ed069142&scoped=true&"
import script from "./RevenueTable.vue?vue&type=script&lang=js&"
export * from "./RevenueTable.vue?vue&type=script&lang=js&"
import style0 from "./RevenueTable.vue?vue&type=style&index=0&id=ed069142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed069142",
  null
  
)

export default component.exports